import React from 'react';
import Panel from './Panel';
import ProposalsList from '../../components/Panel/Proposals/ProposalsList';



const ProposalsAllPage = (e) => {

  if (e.params.table)
    localStorage.setItem('dental_td', e.params.table);
  else
    localStorage.setItem('dental_td', "all");

  return (
    <Panel>
      <div>
        <ProposalsList table={localStorage.getItem('dental_td')} />
      </div>
    </Panel>

  );
};

export default ProposalsAllPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/ProposalsAllPage.js
 **/